"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Navigation = exports.AboutLink = exports.SignoutLink = exports.Username = exports.UserWrapper = exports.WrapperAdmin = exports.Wrapper = exports.Outer = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const polished_1 = require("polished");
const styled_components_1 = require("../styled-components");
const Icons_1 = require("../Icons");
const __1 = require("..");
exports.Outer = styled_components_1.styled.div `
  padding-right: ${({ theme }) => theme.gutterHeader};
  display: flex;
  justify-content: space-between;
  flex: 1;
`;
exports.Wrapper = styled_components_1.styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;
exports.WrapperAdmin = (0, styled_components_1.styled)(exports.Wrapper) `
  flex: 0 0 auto;
  justify-content: flex-end;
  align-items: center;
`;
exports.UserWrapper = styled_components_1.styled.div `
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
`;
exports.Username = styled_components_1.styled.span `
  ${(0, polished_1.ellipsis)(250)}
  @media (max-width: ${({ theme }) => theme.screen.medium}) {
    display: none;
  }
`;
exports.SignoutLink = styled_components_1.styled.a `
  color: ${({ theme }) => theme.link};
  flex: 1;
  margin-left: auto;
  cursor: pointer;
`;
exports.AboutLink = styled_components_1.styled.a `
  cursor: pointer;
  position: relative;
  color: "currentcolor";
  align-self: stretch;
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.gutterHeader} 0;
  white-space: nowrap;
  @media (max-width: ${({ theme }) => theme.screen.small}) {
    padding: 10px;
  }
`;
const Navigation = ({ apiUrl, provisioningId, navigationItems, managementMode, onManagementIconClicked, onAboutButtonCliked, authenticating, versionPopup, appType, isHelios, showBanner, ...authenticatedProps }) => {
    const { t } = (0, react_i18next_1.useTranslation)("central-web-app-components");
    const [showAboutVisibility, setShowAboutVisibility] = react_1.default.useState(false);
    const aboutRef = react_1.default.useRef(null);
    const server = JSON.parse(localStorage.getItem("system"));
    const serverWithExtraFields = {
        ...server,
        provisioningId,
        apiUrl,
    };
    const header = appType === "Edge"
        ? "Renishaw® Edge"
        : appType === "Cloud" || appType === "OnPremises"
            ? "Renishaw® Central"
            : "Renishaw®";
    const { buildInfo, emptyMessage } = versionPopup;
    return (react_1.default.createElement(exports.Outer, null,
        react_1.default.createElement(exports.Wrapper, null, authenticatedProps.authenticated
            ? navigationItems.map((n) => n && (react_1.default.createElement(__1.NavLink, { key: n.display, mode: n.mode, onClick: n.onClick, "data-testid": `page-${n.display}` }, n.display)))
            : null),
        react_1.default.createElement(exports.WrapperAdmin, null,
            react_1.default.createElement(__1.Busy, { show: authenticating }),
            react_1.default.createElement(__1.FlexSpace, null),
            authenticatedProps.authenticated ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(exports.UserWrapper, null,
                    react_1.default.createElement(exports.Username, null, authenticatedProps.username),
                    showBanner && (react_1.default.createElement(exports.SignoutLink, { onClick: () => authenticatedProps.onSignOutLinkClicked(), "data-testid": "link-signOut" }, authenticatedProps.signOutText))),
                react_1.default.createElement(__1.FlexSpace, null),
                react_1.default.createElement(__1.NavLink, { slim: true, mode: managementMode, onClick: onManagementIconClicked, "data-testid": `page-settings` },
                    react_1.default.createElement(Icons_1.Gear, { title: t `button-Manage`, size: 20, fill: "currentColor" })),
                react_1.default.createElement(__1.FlexSpace, null))) : null,
            react_1.default.createElement(exports.AboutLink, { "data-testid": "about-button", ref: aboutRef, onClick: (evt) => {
                    onAboutButtonCliked && onAboutButtonCliked();
                    setShowAboutVisibility(!showAboutVisibility);
                    evt.stopPropagation();
                } },
                react_1.default.createElement(Icons_1.About, { title: t `button-About`, size: 32, fill: "currentColor" })),
            react_1.default.createElement(__1.AboutPopup, { versionInfo: serverWithExtraFields, buildInfo: buildInfo, emptyMessage: emptyMessage, open: showAboutVisibility, onPopupClose: () => setShowAboutVisibility(false), header: header, isHelios: isHelios, referenceElement: aboutRef.current }))));
};
exports.Navigation = Navigation;
//# sourceMappingURL=Navigation.js.map